import {
  IMGIX_BASE_URL,
  IMGIX_IMAGE_FORMATE,
  IMGIX_IMAGE_QUALITY,
  IMGIX_PRODUCTION_BASE_URL
} from '~shared/constants/imgix.constant';

export namespace CategoryImagesUtil {

  export function getCategoryImageSrc(id: string, height: number, width: number): string {
    const imgixBaseUrl = IMGIX_BASE_URL() || IMGIX_PRODUCTION_BASE_URL;
    const imageUrl = buildImageUrl(imgixBaseUrl, id, height, width);

    return `${imageUrl} 1x`;
  }

  export function getCategoryImageSrcSet(id: string, height: number, width: number): string {
    const imgixBaseUrl = IMGIX_BASE_URL() || IMGIX_PRODUCTION_BASE_URL;
    const imageUrl = buildImageUrl(imgixBaseUrl, id, height, width);

    return `${imageUrl} 1x, ${imageUrl}&dpr=2 2x, ${imageUrl}&dpr=3 3x`;
  }

  function buildImageUrl(baseUrl: string, id: string, height: number, width: number): string {
    return `${baseUrl}/category_image/${id}.jpg` +
      `?h=${height}&w=${width}&q=${IMGIX_IMAGE_QUALITY}` +
      `&${IMGIX_IMAGE_FORMATE}=format&fit=max`;
  }

}
